<template>
    <div class="row">
      <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
        <card class="card">
          <div class="card-body">
            <h4 class="card-title mb-4 text-center">Παραγγελία</h4>
            <h5 v-if="paymentDto.comment" class="card-title mb-4 text-center">{{ paymentDto.comment }}</h5>
            <div v-if="paymentDto.status === 'pending'">
              <div v-if="paymentDto.paymentMethod === 'web_banking'" class="text-center">
                <div v-if="selectedCoupon.checked && selectedCoupon.valid && selectedCoupon.discountPercentage > 0">
                  <div class="text-success" style="font-size: 22px;">Έκπτωση {{ selectedCoupon.discountPercentage }}%</div>
                </div>
                <h3>{{ paymentDto.amount }}&euro;</h3>
                <div class="mt-4 text-muted">Πατώντας συνέχεια θα μεταβείτε στο περιβάλλον πληρωμής</div>
                <div><img src="@/assets/img/vw-logo.svg" height="20" alt="viva wallet"></div>
                <div class="mt-4 mb-4 text-muted">όπου θα σας ζητηθεί να κάνετε την πληρωμή στην εταιρεία που λειτουργεί το kodiko.gr</div>
                <div><img src="@/assets/img/bdac-logo.svg" height="70" alt="viva wallet"></div>
                <div>Bid Data Analysis Center (B.D.A.C.)</div>
                <div class="mt-4"><button class="btn btn-success" :disabled="initializingPayment" @click="initializeVivaGateway();">Συνεχεια<span v-if="initializingPayment">...</span></button></div>
                <div v-show="!displayCouponCode" class="text-center mt-3"><a href="javascript:void(0);" @click="displayCouponCode=true">χρήση εκπτωτικού κωδικού</a></div>
                <div v-show="displayCouponCode" class="form-group mt-3" style="max-width: 400px; margin:auto;">
                  <div class="input-group">
                    <input type="text" class="form-control" placeholder="εκπτωτικός κωδικός" v-model="selectedCoupon.couponCode" :disabled="selectedCoupon.checked && selectedCoupon.valid">
                    <div class="input-group-append">
                      <span v-if="selectedCoupon.checked" class="input-group-text" style="background-color: #e3e3e3;">
                        <span v-if="selectedCoupon.valid" style="font-size: 25px;" class="text-success ti-check"></span>
                        <span v-else style="font-size: 25px;" class="text-danger ti-na"></span>
                      </span>
                      <button v-else class="btn btn-sm btn-outline-secondary" style="color:inherit; border-width:1px; margin-left: 1px; font-weight: normal;" @click="applyCoupon" :disabled="checkingCoupon">ελεγχος<span v-if="checkingCoupon">...</span></button>
                    </div>
                  </div>
                  <div v-show="selectedCoupon.checked && selectedCoupon.valid" class="text-center mt-2"><a href="javascript:void(0);" @click="removeCoupon();">αφαίρεση κωδικού</a></div>
                  <div v-show="!selectedCoupon.checked" class="text-center mt-2"><a href="javascript:void(0);" @click="resetSelectedCoupon();displayCouponCode=false;">κλείσιμο</a></div>
                </div>
              </div>
              <div v-else>
                <div id="everypay-pay-form"></div>
                <div class="text-muted">*Τα στοιχεία της κάρτας σας δεν αποθηκεύονται. Χρησιμοποιούνται μόνο από τον πάροχο e-commerce για την ολοκλήρωση της πληρωμής σας</div>
              </div>
            </div>
            <div v-if="activatingPayment" class="text-center text-info">Παρακαλώ περιμένετε...</div>
            <div v-else>
              <div v-if="paymentDto.status === 'error'" class="text-center text-danger">
                <div>Η Πληρωμή απέτυχε</div>
                <div v-if="paymentDto.errorMessage">Σφάλμα: {{ paymentDto.errorMessage }}</div>
                <div class="mt-3"><router-link :to="{path: '/plans'}">νέα προσπάθεια</router-link></div>
              </div>
              <div v-if="paymentDto.status === 'success'" class="text-center text-success">
                <div>Η Πληρωμή έχει ολοκληρωθεί</div>
                <div class="mt-3"><router-link :to="{path: '/payments'}">μετάβαση στις πληρωμές μου</router-link></div>
              </div>
            </div>
            <input id="payment-reference" type="hidden" :value="$route.params.reference_id">
          </div>
        </card>
        <div class="text-center"><router-link :to="{path:'/plans'}">ακύρωση</router-link></div>
        <div class="text-center text-muted mt-4">Για οτιδήποτε χρειαστείτε, είμαστε στη διάθεσή σας στο info@kodiko.gr</div>
      </div>
    </div>
</template>
<script>
import Api from "../api";
export default {
  components: {
    
  },
  data() {
    return {
      fetchingPayment: true,
      activatingPayment: false,
      initializingPayment: false,
      checkingCoupon: false,
      paymentDto: {
        id: null,
        referenceId: null,
        amount: null,
        comment: null,
        status: null,
        errorMessage: null,
        paymentMethod: null
      },
      everypayConfig: {
        payformJsUrl: null,
        publicKey: null,
        billingEmail: null,
        billingCountry: null,
        billingPostalCode: null,
        billingCity: null,
        billingAddress: null
      },
      webBankingConfig: {},
      everypayPayformScriptId: "everypay-payform-script",
      selectedCoupon: {
        couponCode: null,
        discountPercentage: null,
        valid: false,
        checked: false
      },
      displayCouponCode: false
    };
  },
  mounted() {
    this.getPayment();
  },
  methods: {
    getPayment () {
      Api.send("GET", "/payments/" + document.getElementById('payment-reference').value + "/ref", {})
        .then((response) => {
          this.paymentDto.id = response.data.id;
          this.paymentDto.referenceId = response.data.referenceId;
          this.paymentDto.amount = response.data.amount;
          this.paymentDto.comment = response.data.comment;
          this.paymentDto.status = response.data.status;
          this.paymentDto.errorMessage = response.data.errorMessage;
          this.paymentDto.paymentMethod = response.data.paymentMethod;
          if (this.paymentDto.status === 'pending') {
            if (this.paymentDto.paymentMethod === 'web_banking') {
              //this.initializeWebBankingGateway();
            } else {
              //this.initializeEverypayGateway();
            }
          }
          if (response.data.orderProductDto.couponCode) {
            this.selectedCoupon.couponCode = response.data.orderProductDto.couponCode;
            this.selectedCoupon.discountPercentage = response.data.orderProductDto.discountPercentage;
            this.selectedCoupon.valid = true;
            this.selectedCoupon.checked = true;
            this.displayCouponCode = true;
          } else {
            this.resetSelectedCoupon();
            this.displayCouponCode = false;
          }
        })
        .catch((err) => {
          this.$root.notifyy('danger', err.msg);
          this.fetchingPayment = false;
        })
        .finally(() => {
          
        });
    },
    initializeWebBankingGateway () {
      Api.send("GET", "/payments/web_banking/config", {})
        .then((response) => {
          this.webBankingConfig = response;
        })
        .catch((err) => {
          this.$root.notifyy('danger', err.msg);
        })
        .finally(() => {
          this.fetchingPayment = false;
        });
    },
    initializeEverypayGateway () {
      Api.send("GET", "/payments/everypay/config", {})
        .then((response) => {
          this.everypayConfig.payformJsUrl = response.data.payformJsUrl;
          this.everypayConfig.publicKey = response.data.publicKey;
          this.everypayConfig.billingEmail = response.data.billingEmail;
          this.everypayConfig.billingCountry = response.data.billingInvoiceInfo.country;
          this.everypayConfig.billingPostalCode = response.data.billingInvoiceInfo.postalCode;
          this.everypayConfig.billingCity = response.data.billingInvoiceInfo.city;
          this.everypayConfig.billingAddress = response.data.billingInvoiceInfo.address;

          if (!this.$root.isActiveListener('handleEverypayScriptLoaded')) {
            document.addEventListener('scriptLoaded', (e) => {
              if (e.detail === this.everypayPayformScriptId) {
                this.mountEverypayPayform();
              }
            }, false);
            this.$root.addActiveListener('handleEverypayScriptLoaded');
          }

          if (!this.$root.isActiveListener('handleEverypayPaymentCompleted')) {
            document.addEventListener('everypayPaymentCompleted', (e) => {
              this.handleEverypayResponse(JSON.parse(e.detail));
            }, false);
            this.$root.addActiveListener('handleEverypayPaymentCompleted');
          }

          if (document.getElementById(this.everypayPayformScriptId)) {
            this.mountEverypayPayform();
          } else {
            loadExtraScript(this.everypayConfig.payformJsUrl, this.everypayPayformScriptId);
          }
        })
        .catch((err) => {
          this.$root.notifyy('danger', err.msg);
        })
        .finally(() => {
          this.fetchingPayment = false;
        });
    },
    initializeVivaGateway () {
      this.initializingPayment = true;
      Api.send("POST", "/payments/" + document.getElementById('payment-reference').value + "/initialize", {})
      .then((response) => {
        location.replace(response.data.url);
      })
      .catch((err) => {
        this.$root.notifyy('danger', err.msg);
        this.initializingPayment = false;
      })
      .finally(() => {
        
      });
    },
    mountEverypayPayform() {
        everypay.payform({
          pk: this.everypayConfig.publicKey,
          amount: this.paymentDto.amount * 100,
          locale: 'el',
          elementId: 'everypay-pay-form',
          installments: [],
          txnType: "tds",
          theme: "default",
          data: {
            email: this.everypayConfig.billingEmail,
            siteLang: 'el',
            billing: {
              country: this.everypayConfig.billingCountry,
              postalCode: this.everypayConfig.billingPostalCode,
              city: this.everypayConfig.billingCity,
              addressLine1: this.everypayConfig.billingAddress
            }
          },
          formOptions: {
            size: "xl"
          }
        }, emitEverypayResponse);
      },
      handleEverypayResponse(r) {
        if (!r.response) {
          return false;
        }
        if (r.response === 'success') {
          this.activatingPayment = true;
          Api.send("PATCH", "/payments/" + document.getElementById('payment-reference').value + "/activate", {
            token: r.token
          })
            .then((response) => {
              //this.paymentDto.status = 'success';
              //this.paymentDto.errorMessage = null;
            })
            .catch((err) => {
              //this.paymentDto.status = 'error';
              //this.paymentDto.errorMessage = err.msg;
            })
            .finally(() => {
              //this.activatingPayment = false;
              location.reload();
            });
        } else {
          // Inform the user if there was an error
        }
      },
      resetSelectedCoupon() {
        this.selectedCoupon.couponCode = null;
        this.selectedCoupon.discountPercentage = null;
        this.selectedCoupon.valid = false;
        this.selectedCoupon.checked = false;
      },
      applyCoupon() {
        if (!this.selectedCoupon.couponCode || !this.paymentDto.referenceId) {
          return false;
        }

        this.checkingCoupon = true;

        Api.send("POST", "/payments/" + this.paymentDto.referenceId + "/coupon", {coupon: this.selectedCoupon.couponCode})
        .then((response) => {
          this.$root.notifyy('success', response.msg);
          this.getPayment();
        })
        .catch((err) => {
          this.$root.notifyy('danger', err.msg);
        })
        .finally(() => {
          this.checkingCoupon = false;
        });
      },
      removeCoupon() {
        if (!this.paymentDto.referenceId) {
          return false;
        }

        this.checkingCoupon = true;

        Api.send("DELETE", "/payments/" + this.paymentDto.referenceId + "/coupon", {})
        .then((response) => {
          this.$root.notifyy('success', response.msg);
        })
        .catch((err) => {
          this.$root.notifyy('danger', err.msg);
        })
        .finally(() => {
          this.checkingCoupon = false;
          this.getPayment();
        });
      }
  },
};
</script>
<style scoped>
</style>
